import { IController } from 'angular';
import * as _ from 'lodash';
import { StudentPanel } from '../../../../../ng2/shared/constants/student-panel.constant';
import { LocalStorageService } from '../../../../../ng2/shared/services/web-storage/local-storage/local-storage.service';

export class StudentPanelCtrl implements IController {
  static $inject = ['$scope', 'LocalStorageService', 'ToggleService'];

  // Bindings
  private panelHeader;
  private panelId;

  constructor(private $scope, private localStorageService: LocalStorageService) {}

  $onInit() {
    if (!this.panelHeader) {
      const panelHeader = _.find(StudentPanel, { id: this.panelId }).human;
      if (!panelHeader) {
        console.warn(`The panel-id ${this.panelId} is not defined in the StudentPanel constant`);
      } else {
        this.panelHeader = panelHeader;
      }
    }

    const _updatePanels = (panelCollection, scopeProperty) => {
      if (_.includes(this.localStorageService.getItem(panelCollection), this.panelId)) {
        this.$scope[scopeProperty] = true;
      } else {
        this.$scope[scopeProperty] = false;
      }
    };

    this.localStorageService.setItem('ssvHiddenPanels', []);

    // Collapsed Panels:
    if (this.localStorageService.getItem('ssvCollapsedPanels')) {
      _updatePanels('ssvCollapsedPanels', 'isPanelCollapsed');
    } else {
      this.localStorageService.setItem('ssvCollapsedPanels', []);
    }

    // Watch for hidden panel changes in ssv-panel-status-widget
    this.$scope.$watch(
      () => this.localStorageService.getItem('ssvHiddenPanels'),
      () => {
        this.$scope.panelIsHidden = _.includes(this.localStorageService.getItem('ssvHiddenPanels'), this.panelId);
      },
      true,
    );

    // Watch for collapsed panel changes in ssv-panel-status-widget:
    this.$scope.$watch(
      () => this.localStorageService.getItem('ssvCollapsedPanels'),
      () => {
        this.$scope.isPanelCollapsed = _.includes(this.localStorageService.getItem('ssvCollapsedPanels'), this.panelId);
      },
      true,
    );

    // fires when manually toggling panels in SSV:
    this.$scope.togglePanel = () => {
      let ssvCollapsedPanels = this.localStorageService.getItem('ssvCollapsedPanels') || [];

      this.$scope.isPanelCollapsed = !this.$scope.isPanelCollapsed;

      if (this.$scope.isPanelCollapsed) {
        // Add to storage
        ssvCollapsedPanels.push(this.panelId);
        ssvCollapsedPanels = _.uniq(ssvCollapsedPanels);
      } else {
        // Remove from storage
        ssvCollapsedPanels = _.without(ssvCollapsedPanels, this.panelId);
        this.localStorageService.setItem('ssvOpenPanels', ssvCollapsedPanels);
      }

      this.localStorageService.setItem('ssvCollapsedPanels', ssvCollapsedPanels);
    };

    // For detecting the type of summaryItem
    this.$scope.isString = item => typeof item === 'string';
    this.$scope.isObject = item => typeof item === 'object';
  }
}
